import { createFileRoute } from '@tanstack/react-router';
import PasswordReset from '@src/pages/Auth/PasswordReset';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/auth/password-reset')({
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle('auth.reset_password_title', 'Reset Password'),
      },
    ],
  }),
  component: PasswordReset,
});
